import React from 'react'
import {useInView} from 'react-intersection-observer'
import styled from 'styled-components'

import InlineVideo from '@helios/shared/types/inline-video'

interface Props extends React.VideoHTMLAttributes<HTMLVideoElement> {
    video: InlineVideo
    posterWidth?: number
    posterHeight?: number
}

export const Video = React.forwardRef<HTMLVideoElement, Props>(
    ({video, poster, posterWidth, posterHeight, ...props}, ref) => {
        const [videoContainerRef, inView] = useInView({
            threshold: 0,
            triggerOnce: true,
        })
        let posterSrc = ''

        if (poster) {
            const [canonical, defaultParams] = poster.split('?')
            const params = new URLSearchParams(defaultParams)

            params.append('dpr', '2')

            if (posterWidth) {
                params.append('w', posterWidth.toString())
            }

            if (posterHeight) {
                params.append('h', posterHeight.toString())
            }

            posterSrc = `${canonical}?${params.toString()}`
        }

        return (
            <div ref={videoContainerRef}>
                <StyledVideo
                    poster={posterSrc}
                    ref={ref}
                    loop
                    autoPlay
                    playsInline
                    muted
                    {...props}
                >
                    {inView && video.webm && (
                        <source key="webm" src={video.webm} type="video/webm" />
                    )}
                    {inView && video.mp4 && <source key="mp4" src={video.mp4} type="video/mp4" />}
                </StyledVideo>
            </div>
        )
    }
)

const StyledVideo = styled.video`
    display: block;
    width: 100%;
    max-width: 100%;
    object-fit: inherit;
`
